import {
    getBySelector,
    getValueBySelector,
    hideElementsBySelector,
    showElementsBySelector
} from "@/helpers/element-helper";
import {addLayerActive} from "@/helpers/ol/ol-layer-active-helper";
import $ from "jquery";
import {zoomToExtent} from "@/helpers/ol/ol-zoom-helper";
import {loadInfo} from "@/helpers/layer/info/layer-info-info-helper";
import {showLayerInfoButton} from "@/helpers/layer/info/layer-info-helper";
import {updateInfoLegends} from "@/helpers/layer/info/layer-info-legend-helper";
import {transformExtent} from "ol/proj";
import {uploadShape} from "@/http/services/http-services-shape";
import {createGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";
import {addServiceWmtsWithOptions} from "@/modules/ol/service/ol-service-wmts";
import {OlService} from "@/modules/ol/service/ol-service";
import {getBookmarkPresentationsByID, getLayerNamePrefix} from "@/helpers/ol/ol-layer-helper";
import {getDefaultStyleFunction} from "@/helpers/ol/ol-style-helper";
import {isValidUrl} from "@/helpers/url/url-params-helper";
import {showNotification} from "@/helpers/notification-helper";
import {stopLadda} from "@/helpers/ladda-helper";

import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {inflateCoordinatesArray} from "ol/geom/flat/inflate";
import {fromCircle} from "ol/geom/Polygon.js";

let temporaryLayers = []
let csvSymbol = ''

export function getTemporaryLayers() {
    return temporaryLayers
}

export function removeTemporaryLayer(id) {
    if(id.includes('temporary')) {
        temporaryLayers = temporaryLayers.filter(layer => !layer.get('name').includes(id))
    }
    updateInfoLegends()
}

export function addTemporaryLayer(type, layerCapabilities, layerName = undefined, capabilities = undefined) {
    switch (type) {
        case 'SHP':
        case 'CSV':
        case 'GeoJson':
            addTemporaryLayerFile(type)
            break;
        default:
            const url = getValueBySelector('#iptServiceUrl')
            addTemporaryLayerService(type, url, layerName, layerCapabilities, capabilities)
            break;
    }
}

export function addTemporaryLayerService(type, url, layerName = '', layerCapabilities = undefined, capabilities = undefined, userSessionBookmarkPresentation = undefined) {
    //// console.log(temporaryLayers)
    const name = 'temporary-' + temporaryLayers.length
    const service = {}
    service.Url = url
    service.Layer = layerName
    service.Type = type
    service.id = name
    service.Styles = ['']
    service.Service = {}
    service.Service.Projection = getViewProjectionName()

    if(type === 'WMTS') {
        service.zIndex = -1;
    }
    if(type === 'ArcGISMapServer') {
        service.Untiled = true
    }

    let boundingBox
    let capability

    console.log(layerCapabilities)

    if(layerCapabilities) {
        capability = layerCapabilities.find(capability =>
            capability.Name === service.Layer ||
            capability.Identifier === service.Layer ||
            capability.Abstract === service.Layer
        )

        if (capability) {


            // WMTS
            if(capability.TileMatrixSetLink) {
                if(capability.TileMatrixSetLink.find(TileMatrixSetLink => TileMatrixSetLink.TileMatrixSet === 'EPSG:28992')) {
                    service.Service.Projection = 'EPSG:28992'
                } else {
                    // console.log(capability)
                    const matrixSet = capability.TileMatrixSetLink[0].TileMatrixSet
                    const layer = addServiceWmtsWithOptions(name, layerName, matrixSet, capabilities)
                    layer.Name = layerName
                    if (capability) {
                        layer.Styles = capability.Style
                    }
                    layer.BoundingBox = boundingBox
                    temporaryLayers.push(layer)
                    addLayerActive(name, layerName, true, 'temporary')
                    updateInfoLegends()
                    return
                }
            }

            //// console.log(capability)

            // WMS
            if(capability.BoundingBox) {
                if(capability.Style) {
                    service.Styles = [capability.Style[0].Name]
                }

                boundingBox = capability.BoundingBox.find(boundingBox => boundingBox.crs ===  getViewProjectionName())

                if (boundingBox) {
                    service.Extent = boundingBox.extent
                } else {
                    service.Service.Projection = 'EPSG:28992'
                    boundingBox = capability.BoundingBox.find(boundingBox => boundingBox.crs === 'EPSG:28992')
                }
            }
        }
    } else {
        if(userSessionBookmarkPresentation) {
            service.Service.Projection = userSessionBookmarkPresentation.ServiceLayerProjection

            boundingBox = {}
            boundingBox.extent = userSessionBookmarkPresentation.ServiceLayerExtent.split(',').map(num => parseInt(num));
            boundingBox.crs = userSessionBookmarkPresentation.ServiceLayerProjection
            service.Styles = []
        }
    }

    console.log(boundingBox)

    service.service = service
    let olService = new OlService(service);
    const layer = olService.addLayer(window.map)

    if(layer) {
        layer.Name = layerName
        if (capability) {
            layer.Styles = capability.Style
        }
        layer.BoundingBox = boundingBox
        temporaryLayers.push(layer)
    }

    addLayerActive(name, layerName, true, 'temporary')

    updateInfoLegends()

    stopLadda()
}

export function addTemporaryLayerFile(type) {
    const name = 'temporary-' + temporaryLayers.length
    const formData = new FormData();
    const files = getBySelector('#iptServiceFile').files;
    let file
    for (let i = 0; i < files.length; i++) {
        file = files[i];
        formData.append('shpupload', file, file.name);
    }

    let icon = 'fa fa-file-archive'
    if(type === 'CSV') {
        icon = 'fa fa-file-csv'

        let hasColumns =false
        getBySelector('#tblCsvFile').querySelectorAll('select').forEach(element => {
            hasColumns = true
            formData.append('kolomselected[]', element.value);
        })

        if(hasColumns) {
            formData.append('symbool', csvSymbol);
        }
    }
    if(type === 'GeoJson') {
        icon = 'fa fa-file-code'
    }

    if(file.name) {
        let layerName = file.name.replace('.zip', '')
        uploadShape(formData).then((result) => {

            stopLadda()

            if(!result) {
                showNotification('Het uploaden is niet gelukt. Neem contact op met de beheerder', '', 'error')
            }

            if(result.errors && result.features.length === 0) {
                showNotification(result.errors, '', 'error')
                return
            }

            if(result.kolommen) {
                loadCsvTable(result.kolommen, result.symbool)
                return
            }

            const layer = createGeoJsonLayer(result, String(temporaryLayers.length), true, getLayerNamePrefix() + 'temporary', getDefaultStyleFunction(), getViewProjectionName())
            const boundingBox = layer.getSource().getExtent()

            layer.Name = layerName
            layer.BoundingBox = boundingBox
            temporaryLayers.push(layer)

            addLayerActive(name, layerName, true, 'temporary', icon)
            zoomToExtent(boundingBox)
            stopLadda()
        })
    }
    stopLadda()
}

export function loadTemporaryLayers(coordinate, result) {

        temporaryLayers.map((temporaryLayer, key) => {
            if(temporaryLayer.styleFunction_) {
                return;
            }

            const url = temporaryLayer.getSource().getFeatureInfoUrl(
                coordinate,
                window.map.getView().getResolution(),
                getViewProjectionName(),
                {'INFO_FORMAT': 'application/json'}
            )
            if (url) {

                // console.log(url)

                $.ajax({
                    url: url,
                    async: false,
                    dataType: 'json',
                    success: function (response) {
                        if(response.features && response.features.length > 0) {
                            const mainTab = generateTemporaryLayer(temporaryLayer.Name, response.features[0].geometry, response.features)
                            result.mainTabs.push(mainTab)
                        }
                    }
                });
            }
        })
    return result
}

export function getTemporaryLayerByIndex(index) {
    // console.log(temporaryLayers)
    // console.log(index)
    return temporaryLayers[index.replace('temporary-', '').replace(getLayerNamePrefix(), '')]
}

export function zoomToTemporaryLayer(id) {
    const layer = getTemporaryLayerByIndex(id)

    if(layer.BoundingBox && layer.BoundingBox.crs === 'EPSG:28992') {
        return new transformExtent(layer.BoundingBox.extent, "EPSG:28992", getViewProjectionName())
    }

    if(layer.getExtent()) {
        return layer.getExtent()
    }

    return layer.getSource().getExtent()
}

export function loadTemporaryLayerInfo(layer, feature) {

    let name = getTemporaryLayerByIndex(layer.get('name'))
    if(name) {
        name = name.Name
    } else {
        const bookmarkPresentation = getBookmarkPresentationsByID(layer.get('name').replace('layer-', ''))
        if(bookmarkPresentation) {
            name = bookmarkPresentation.DisplayName
        }
    }

    if(!name) {
        name = ''
    }
    //// console.log('loadTemporaryLayerInfo')

    const result = {}
    result.mainTabs = []

    const properties = feature.getProperties()
    const geometry = {}
    if(properties && feature.get('geometry') === undefined) {
        feature.properties = properties
        feature.projection = getViewProjectionName()

        // console.log(feature)
        if(feature.getFlatCoordinates()) {
            geometry.coordinates = inflateCoordinatesArray(
                feature.getFlatCoordinates(), // flat coordinates
                0, // offset
                feature.getEnds(), // geometry end indices
                2, // stride
            )
        }
        geometry.type = feature.getType()
    } else {
        feature.properties = {}
        feature.getKeys().map((key) => {
            if (key !== 'geometry' && feature.get(key)) {
                feature.properties[key] = feature.get(key)
            }
        })
        geometry.coordinates = feature.get('geometry').getCoordinates()
        geometry.type = feature.get('geometry').getType()

        if(geometry.type === 'Circle') {
            geometry.coordinates = inflateCoordinatesArray(
                fromCircle(feature.getGeometry().clone()).getFlatCoordinates(), // flat coordinates
                0, // offset
                fromCircle(feature.getGeometry().clone()).getEnds(), // geometry end indices
                2, // stride
            )
            geometry.type = 'Polygon'
        }
    }

    console.log(feature)

    result.mainTabs.push(generateTemporaryLayer(name, geometry, [feature]))
    loadInfo(result)
    showLayerInfoButton('layer-info-info', false)

    if(properties && properties.style && properties.style.strokeColor) {
        document.querySelector('layer-info-info-geometry-measure-button').firstChild.click()
        hideElementsBySelector('layer-info-info-geometry-measure-back-button')
    }
}

export function generateTemporaryLayer(name, geometry, features) {
    const mainTab = {}
    mainTab.Name = name
    mainTab.features = []

    const feature = {}
    feature.featureInfo = []
    feature.feature = {}
    feature.feature.geometry = geometry
    feature.feature.projection = getViewProjectionName()

    const featureInfo = {}
    featureInfo.records = []
    featureInfo.ApplicationID = 0
    featureInfo.FormName = name
    featureInfo.FormType = 1

    const record = {}

    features.map((feature) => {
        record.attributes = []
        record.geometry = geometry
        for (const [key, value] of Object.entries(feature.properties)) {
            if(value) {

                let type = 0
                if(isValidUrl(String(value))) {
                    type = 3
                }

                // console.log(value)

                record.attributes.push(
                    [
                        {DisplayName: key, Value: value, Type: type}
                    ]
                )
            }
        }
        featureInfo.records.push(record)
    })

    feature.featureInfo.push(featureInfo)

    mainTab.features.push(feature)

    return mainTab
}

export function loadCsvTable(columns, symbol) {
    let innerHTML = ''

    let select = '<select size="1" class="form-control"><option value="">Tekst</option><option value="X-coord">X coördinaat</option><option value="Y-coord">Y coördinaat</option><option value="Lat-coord">Lat coördinaat</option><option value="Lon-coord">Lon coördinaat</option><option value="Adres-deel-1">Adres deel 1</option><option value="Adres-deel-2">Adres deel 2</option><option value="Adres-deel-3">Adres deel 3</option></select>'
    columns.map( column => {
        innerHTML += '<tr><td>' + column.naam + '</td><td>' + select + '</td></tr>'
    })

    csvSymbol = symbol

    getBySelector('#tblCsvFile').innerHTML = innerHTML
}
